<div class="ex-modal-header">
  <div class="ex-modal-title">{{ 'features.smart-search.modal-title' | translate }}</div>
  <ex-button icon="x-bold" type="secondary" variant="ghost" size="small" (click)="modal.dismiss()"></ex-button>
</div>
<div class="ex-modal-body">
  <div class="feature-description" [innerHTML]="'features.smart-search.body' | translate"></div>
  <video
    class="ex-modal-media m-auto"
    controls
    height="280"
    src="assets/videos/decouvrez-les-analyses-ia.mp4"
    poster="assets/images/feature-thumbnail-smart-search.svg"
  ></video>
</div>
<div class="ex-modal-footer">
  <div class="modal-footer-group">
    <ex-button type="primary" variant="raised" (click)="modal.close()">{{ 'features.smart-search.modal-confirm' | translate }}</ex-button>
  </div>
</div>
